import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(snackbarOpenSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(snackbarOpenSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(snackbarCloseSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(snackbarCloseSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(snackbarCloseWithAnswerSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(snackbarCloseWithAnswerSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(snackbarsSaga);

import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { ConstantsUtil } from '@utils';
import { INIT_CLOSE_SNACKBAR, INIT_SNACKBAR_CLOSING_WITH_ANSWER, SNACKBAR_INIT } from './snackbars.action-types';
import { actions } from './snackbars.actions';

/**
 * Open snackbar saga worker.
 *
 * @author Mikhail Siutsou
 * @function snackbarOpenSagaWorker
 * @category Sagas
 * @subcategory Snackbars
 * @return {Generator<PutEffect>} action data.
 */
function snackbarOpenSagaWorker(action) {
  return _regeneratorRuntime.wrap(function snackbarOpenSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.setSnackbar({
            snackbarId: action.payload.snackbarId,
            isOpen: action.payload.isOpen,
            data: action.payload.data
          }));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Set new snackbar to saga watcher.
 *
 * @author Mikhail Siutsou
 * @function snackbarOpenSagaWatcher
 * @category Sagas
 * @subcategory Snackbars
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function snackbarOpenSagaWatcher() {
  return _regeneratorRuntime.wrap(function snackbarOpenSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(SNACKBAR_INIT, snackbarOpenSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Close snackbar saga worker.
 *
 * @author Mikhail Siutsou
 * @function snackbarCloseSagaWorker
 * @category Sagas
 * @subcategory Snackbars
 * @return {Generator<PutEffect>} action data.
 */


function snackbarCloseSagaWorker(action) {
  return _regeneratorRuntime.wrap(function snackbarCloseSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(actions.snackbarClose({
            snackbarId: action.payload.snackbarId
          }));

        case 2:
          _context3.next = 4;
          return put({
            type: "".concat(SNACKBAR_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              snackbarId: action.payload.snackbarId
            }
          });

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 * Close snackbar.
 *
 * @author Mikhail Siutsou
 * @function snackbarCloseSagaWatcher
 * @category Sagas
 * @subcategory Snackbars
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function snackbarCloseSagaWatcher() {
  return _regeneratorRuntime.wrap(function snackbarCloseSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(INIT_CLOSE_SNACKBAR, snackbarCloseSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Close snackbar with answer saga worker.
 *
 * @author Mikhail Siutsou
 * @function snackbarCloseWithAnswerSagaWorker
 * @category Sagas
 * @subcategory Snackbars
 * @return {Generator<PutEffect>} action data.
 */


function snackbarCloseWithAnswerSagaWorker(action) {
  return _regeneratorRuntime.wrap(function snackbarCloseWithAnswerSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(actions.closeWithAnswer({
            snackbarId: action.payload.snackbarId,
            accepted: action.payload.accepted,
            rejected: action.payload.rejected
          }));

        case 2:
          if (!action.payload.accepted) {
            _context5.next = 7;
            break;
          }

          _context5.next = 5;
          return put({
            type: "".concat(SNACKBAR_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              snackbarId: action.payload.snackbarId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected
            }
          });

        case 5:
          _context5.next = 9;
          break;

        case 7:
          _context5.next = 9;
          return put({
            type: "".concat(SNACKBAR_INIT, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            error: {
              snackbarId: action.payload.snackbarId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected
            }
          });

        case 9:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/**
 * Close snackbar with answer.
 *
 * @author Mikhail Siutsou
 * @function snackbarCloseWithAnswerSagaWatcher
 * @category Sagas
 * @subcategory Snackbars
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function snackbarCloseWithAnswerSagaWatcher() {
  return _regeneratorRuntime.wrap(function snackbarCloseWithAnswerSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(INIT_SNACKBAR_CLOSING_WITH_ANSWER, snackbarCloseWithAnswerSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * Snackbars saga.
 *
 * @author Mikhail Siutsou
 * @function snackbarsSaga
 * @category Sagas
 * @subcategory Snackbars
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


export default function snackbarsSaga() {
  return _regeneratorRuntime.wrap(function snackbarsSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return all([fork(snackbarOpenSagaWatcher), fork(snackbarCloseSagaWatcher), fork(snackbarCloseWithAnswerSagaWatcher)]);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}